const PATH = {
  HOME: '/',
  LOGIN: '/login',
  UNAUTHORIZED: '/unauthorized',
  REPORT: {
    ROOT: '/report',
    REVENUE: '/report/revenue',
    REGISTER: '/report/register',
    PIECE_STATS: '/report/piece-statistics',
    LOGIN_STATS: '/report/login-statistics',
    GAME_STATS: '/report/game-statistics',
    LOGIN_STREAK: '/report/login-streak',
    OPEN_BOX: '/report/open-box',
  },
  PRIZE_MANAGEMENT: {
    ROOT: '/prize-management',
    CREATE: '/prize-management/create',
    UPDATE: '/prize-management/:id',
    PIECE_UPDATE: '/prize-management/piece-update',
  },
  CUSTOMER_CARE: {
    ROOT: '/customer-care',
    CHARGE_HISTORY: '/customer-care/charge-history',
    REGISTER_CANCEL_HISTORY: '/customer-care/register-cancel-history',
    FREE_PLAY: '/customer-care/free-play',
    SOLO_MODE_PLAY_HISTTORY: '/customer-care/solo-mode-play-history',
    MULTIPLAYER_MODE_PLAY_HISTORY: '/customer-care/multiplayer-mode-play-history',
    PRIZE_STATS: '/customer-care/prize-statistics',
  },
  USER_KEY_MANAGEMENT: {
    ROOT: '/user-key-management',
  },
  MISSIONS: {
    ROOT: '/missions',
    CREATE: '/missions/create',
    UPDATE: '/missions/:id',
  },
  QUESTIONS: '/questions',
  WHEEL: {
    ROOT: '/wheel',
    CREATE: '/wheel/create',
    UPDATE: '/wheel/:id',
  },
  MSISDN_BLOCK: {
    ROOT: '/msisdn-block',
    CREATE: '/msisdn-block/create',
  },
  TOPIC: {
    ROOT: '/topics',
    CREATE: '/topics/create',
    UPDATE: '/topics/:id',
    CONFIG: '/topics/config',
  },
  TOPIC_ANSWER: {
    ROOT: '/topic-answers',
    CREATE: '/topic-answers/create',
    UPDATE: '/topic-answers/:id',
  },
  SEND_SMS: {
    ROOT: '/send-sms',
    DETAIL: '/send-sms/:id',
  },
  CONFIG: '/configuration',
  BOX_MANAGEMENT: '/box-management',
  THEME_MANAGEMENT: {
    ROOT: '/theme-management',
    CREATE: '/theme-management/create',
    UPDATE: '/theme-management/:id',
  },
};

export default PATH;
